(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishFutsalLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const OFFICIAL = resolveOfficial('FUTSAL');
  const OFFICIAL_RAW = (OFFICIAL && OFFICIAL.official) || {};
  const OFFICIAL_FEATURE = OFFICIAL && OFFICIAL.features && OFFICIAL.features.futsal;
  const DEFAULTS = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || 40,
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || 20,
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || 0.08,
    GOAL_WIDTH: Number(OFFICIAL_RAW.goalWidth) || 3,
    GOAL_OUTSIDE_WIDTH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.goalOutsideWidthM) || Number(OFFICIAL_RAW.goalOutsideWidth) || 3.16,
    GOAL_HEIGHT: Number(OFFICIAL_RAW.goalHeight) || 2,
    PENALTY_SPAN: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.penaltyAreaWidthM) || 15.16,
    PENALTY_DEPTH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.penaltyAreaDepthM) || 6,
    PENALTY_JOIN_LINE: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.penaltyAreaJoinLineLengthM) || Number(OFFICIAL_RAW.goalOutsideWidth) || 3.16,
    PENALTY_MARK: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.penaltyMarkCenterFromGoalLineM) || 6,
    PENALTY_MARK_R: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.penaltyMarkRadiusM) || 0.06,
    SECOND_MARK: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.secondPenaltyMarkCenterFromGoalLineM) || 10,
    SECOND_MARK_SIDE_OFFSET: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.secondPenaltySideMarkOffsetM) || 5,
    SECOND_MARK_SIDE_R: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.secondPenaltySideMarkRadiusM) || 0.04,
    GOALKEEPER_DISTANCE_MARK_FROM_SECOND: Number(OFFICIAL_RAW.goalkeeperMarkFromSecond) || 5,
    GOALKEEPER_DISTANCE_MARK_LENGTH: Number(OFFICIAL_RAW.goalkeeperMarkLength) || 0.4,
    SUBSTITUTION_MARK_DISTANCE_FROM_HALF: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.substitutionMarkDistanceFromHalfwayM) || 5,
    SUBSTITUTION_ZONE_LENGTH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.substitutionZoneLengthM) || 5,
    SUBSTITUTION_MARK_LENGTH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.substitutionMarkLengthM) || 0.8,
    SUBSTITUTION_TOUCHLINE: String((OFFICIAL_FEATURE && OFFICIAL_FEATURE.substitutionTouchline) || 'top').toLowerCase(),
    CENTER_R: Number(OFFICIAL_RAW.centerR) || 3,
    CORNER_R: Number(OFFICIAL_RAW.cornerR) || 0.25,
    CORNER_DISTANCE_MARK_DISTANCE: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.cornerDistanceMarkDistanceM) || 5,
    CORNER_DISTANCE_MARK_GAP: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.cornerDistanceMarkGapFromGoalLineM) || 0.05,
    CORNER_DISTANCE_MARK_LENGTH: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.cornerDistanceMarkLengthM) || 0.4
  };
  const SKIP_COLOR = '__SKIP__';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }
  function hasKeys(obj) { if (!obj) return false; for (const _ in obj) return true; return false; }
  function pos(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }
  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function computeDims(cw, ch, opts) {
    const L = pos(opts && opts.playableLengthM, DEFAULTS.LENGTH);
    const W = pos(opts && opts.playableWidthM, DEFAULTS.WIDTH);
    const line = pos(opts && opts.lineWidthM, DEFAULTS.LINE);
    const goal = Math.min(pos(opts && opts.goalWidthM, DEFAULTS.GOAL_WIDTH), Math.max(0.1, W));
    const goalOutside = Math.min(pos(opts && opts.goalOutsideWidthM, DEFAULTS.GOAL_OUTSIDE_WIDTH), Math.max(0.1, W));
    const spanRaw = pos(
      (opts && (opts.futsalPenaltyAreaWidthM || opts.penaltyAreaWidthM)),
      DEFAULTS.PENALTY_SPAN
    );
    const depthRaw = pos(
      (opts && (opts.futsalPenaltyAreaLengthM || opts.penaltyAreaLengthM)),
      DEFAULTS.PENALTY_DEPTH
    );
    const depth = Math.max(0.01, depthRaw);
    const officialJoin = pos(opts && opts.penaltyAreaJoinLineLengthM, DEFAULTS.PENALTY_JOIN_LINE);
    const span = Math.max(goalOutside, spanRaw);
    const join = Math.max(goalOutside, Math.min(span, Math.max(officialJoin, span - (depth * 2))));
    const scaleX = cw / Math.max(0.001, L);
    const scaleY = ch / Math.max(0.001, W);
    return {
      L,
      W,
      line,
      goal,
      goalOutside,
      span,
      depth,
      join,
      centerR: pos(opts && opts.centerCircleRadiusM, DEFAULTS.CENTER_R),
      cornerR: pos(opts && opts.cornerArcRadiusM, DEFAULTS.CORNER_R),
      penaltyMark: pos(opts && opts.penaltyMarkM, DEFAULTS.PENALTY_MARK),
      penaltyMarkR: pos(opts && opts.penaltyMarkRadiusM, DEFAULTS.PENALTY_MARK_R),
      secondMark: pos(opts && opts.secondPenaltyMarkM, DEFAULTS.SECOND_MARK),
      secondMarkSideOffset: pos(opts && opts.secondPenaltySideMarkOffsetM, DEFAULTS.SECOND_MARK_SIDE_OFFSET),
      secondMarkSideR: pos(opts && opts.secondPenaltySideMarkRadiusM, DEFAULTS.SECOND_MARK_SIDE_R),
      goalkeeperMarkFromSecond: pos(opts && opts.goalkeeperDistanceMarkFromSecondM, DEFAULTS.GOALKEEPER_DISTANCE_MARK_FROM_SECOND),
      goalkeeperMarkLength: pos(opts && opts.goalkeeperDistanceMarkLengthM, DEFAULTS.GOALKEEPER_DISTANCE_MARK_LENGTH),
      substitutionMarkDistanceFromHalf: pos(opts && opts.substitutionMarkDistanceFromHalfwayM, DEFAULTS.SUBSTITUTION_MARK_DISTANCE_FROM_HALF),
      substitutionZoneLength: pos(opts && opts.substitutionZoneLengthM, DEFAULTS.SUBSTITUTION_ZONE_LENGTH),
      substitutionMarkLength: pos(opts && opts.substitutionMarkLengthM, DEFAULTS.SUBSTITUTION_MARK_LENGTH),
      substitutionTouchline: String((opts && opts.substitutionTouchline) || DEFAULTS.SUBSTITUTION_TOUCHLINE || 'top').toLowerCase(),
      cornerDistanceMarkDistance: pos(opts && opts.cornerDistanceMarkDistanceM, DEFAULTS.CORNER_DISTANCE_MARK_DISTANCE),
      cornerDistanceMarkGap: pos(opts && opts.cornerDistanceMarkGapFromGoalLineM, DEFAULTS.CORNER_DISTANCE_MARK_GAP),
      cornerDistanceMarkLength: pos(opts && opts.cornerDistanceMarkLengthM, DEFAULTS.CORNER_DISTANCE_MARK_LENGTH),
      scaleX,
      scaleY,
      scaleAvg: (scaleX + scaleY) * 0.5,
      fixedLineWidthPx: Math.max(0, Number(opts && opts.fixedLineWidthPx) || 0),
      cw,
      ch
    };
  }

  function mx(d, x) { return x * d.scaleX; }
  function my(d, y) { return y * d.scaleY; }
  function lineWidthPx(d, widthM) {
    return d.fixedLineWidthPx || Math.max(1, (widthM || d.line) * d.scaleAvg);
  }
  function mirrorX(d, side, x) { return side === 'right' ? d.L - x : x; }

  function fillRect(ctx, d, color, x, y, w, h) {
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: d.hardwood, pattern: d.pattern, patternTarget: d.patternTarget, pixelsPerMeter: d.scaleAvg })
      : color;
    ctx.fillRect(mx(d, x), my(d, y), w * d.scaleX, h * d.scaleY);
  }

  function fillPerimeterStrip(ctx, d, color, edge) {
    const lineW = Math.min(d.cw, lineWidthPx(d, d.line));
    const lineH = Math.min(d.ch, lineWidthPx(d, d.line));
    ctx.save();
    ctx.fillStyle = color;
    if (edge === 'top') {
      ctx.fillRect(0, 0, d.cw, lineH);
    } else if (edge === 'bottom') {
      ctx.fillRect(0, Math.max(0, d.ch - lineH), d.cw, lineH);
    } else if (edge === 'left') {
      ctx.fillRect(0, 0, lineW, d.ch);
    } else if (edge === 'right') {
      ctx.fillRect(Math.max(0, d.cw - lineW), 0, lineW, d.ch);
    }
    ctx.restore();
  }

  function strokeLine(ctx, d, color, x1, y1, x2, y2, widthM) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidthPx(d, widthM);
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(mx(d, x1), my(d, y1));
    ctx.lineTo(mx(d, x2), my(d, y2));
    ctx.stroke();
    ctx.restore();
  }

  function strokeCircle(ctx, d, color, x, y, r, widthM) {
    if (!(r > 0)) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidthPx(d, widthM);
    ctx.beginPath();
    ctx.ellipse(mx(d, x), my(d, y), r * d.scaleX, r * d.scaleY, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.restore();
  }

  function fillCircle(ctx, d, color, x, y, rM) {
    const r = Math.max(0.03, Number(rM) || (d.line * 1.25));
    ctx.save();
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.ellipse(mx(d, x), my(d, y), r * d.scaleAvg, r * d.scaleAvg, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  function penaltyPath(ctx, d, side, inset = 0) {
    const centerY = d.W * 0.5;
    const halfJoin = Math.max(d.goalOutside || d.goal, d.join) * 0.5;
    const radiusX = Math.max(0.01, d.depth - inset);
    const radiusY = Math.max(0.01, (d.span - (halfJoin * 2)) * 0.5 - inset);
    const topCenterY = centerY - halfJoin;
    const bottomCenterY = centerY + halfJoin;
    // Distances enclose the complete painted stripe. Use true quarter-circle
    // paths rather than polygon chords, and inset stroke centres by half width.
    const mirrored = side === 'right';
    const x = mx(d, mirrorX(d, side, 0));
    ctx.moveTo(x, my(d, topCenterY - radiusY));
    ctx.ellipse(x, my(d, topCenterY), radiusX * d.scaleX, radiusY * d.scaleY,
      0, -Math.PI / 2, mirrored ? -Math.PI : 0, mirrored);
    ctx.lineTo(mx(d, mirrorX(d, side, radiusX)), my(d, bottomCenterY));
    ctx.ellipse(x, my(d, bottomCenterY), radiusX * d.scaleX, radiusY * d.scaleY,
      0, mirrored ? Math.PI : 0, Math.PI / 2, mirrored);
  }

  function fillPenaltyArea(ctx, d, color, side) {
    ctx.save();
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: d.hardwood, pattern: d.pattern, patternTarget: d.patternTarget, pixelsPerMeter: d.scaleAvg })
      : color;
    ctx.beginPath();
    penaltyPath(ctx, d, side);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  function strokePenaltyArea(ctx, d, color, side) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidthPx(d, d.line);
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    penaltyPath(ctx, d, side, d.line * 0.5);
    ctx.stroke();
    ctx.restore();
  }

  function strokeCornerArcs(ctx, d, color) {
    const r = Math.max(0.001, Math.min(d.cornerR, d.L * 0.5, d.W * 0.5) - d.line * 0.5);
    const linePx = lineWidthPx(d, d.line);
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = linePx;
    ctx.lineCap = 'butt';
    const arc = (x, y, start, end) => {
      ctx.beginPath();
      ctx.ellipse(mx(d, x), my(d, y), r * d.scaleX, r * d.scaleY, 0, start, end);
      ctx.stroke();
    };
    arc(0, 0, 0, Math.PI / 2);
    arc(d.L, 0, Math.PI / 2, Math.PI);
    arc(d.L, d.W, Math.PI, Math.PI * 1.5);
    arc(0, d.W, Math.PI * 1.5, Math.PI * 2);
    ctx.restore();
  }

  function strokeCornerDistanceMarks(ctx, d, color) {
    // FIFA Law 1: 5 m from the corner arc; keep the existing mark centering.
    const distance = clamp(d.cornerR + d.cornerDistanceMarkDistance, 0, d.W);
    const gap = Math.max(0, d.cornerDistanceMarkGap);
    const len = Math.max(d.line, d.cornerDistanceMarkLength);
    [distance, d.W - distance].forEach((y) => {
      strokeLine(ctx, d, color, -gap, y, -(gap + len), y, d.line);
      strokeLine(ctx, d, color, d.L + gap, y, d.L + gap + len, y, d.line);
    });
  }

  function drawGoal(ctx, d, color, side) {
    const c = d.W * 0.5;
    const y1 = c - d.goal * 0.5;
    const y2 = c + d.goal * 0.5;
    const x = side === 'right' ? d.L : 0;
    const postX = side === 'right' ? d.L - Math.min(0.12, d.depth * 0.04) : Math.min(0.12, d.depth * 0.04);
    strokeLine(ctx, d, color, x, y1, x, y2, d.line * 1.8);
    strokeLine(ctx, d, color, x, y1, postX, y1, d.line);
    strokeLine(ctx, d, color, x, y2, postX, y2, d.line);
  }

  function strokeGoalkeeperDistanceMark(ctx, d, color, side) {
    const xFromGoal = clamp(d.secondMark - d.goalkeeperMarkFromSecond + (d.line * 0.5), 0, d.L);
    if (!(xFromGoal > 0)) return;
    const x = side === 'right' ? d.L - xFromGoal : xFromGoal;
    const markLength = Math.max(d.line, d.goalkeeperMarkLength);
    const y1 = (d.W * 0.5) - (markLength * 0.5);
    const y2 = (d.W * 0.5) + (markLength * 0.5);
    strokeLine(ctx, d, color, x, y1, x, y2, d.line);
  }

  function fillSecondPenaltySideMarks(ctx, d, color, side) {
    const x = side === 'right' ? clamp(d.L - d.secondMark, 0, d.L) : clamp(d.secondMark, 0, d.L);
    const offset = Math.max(0, d.secondMarkSideOffset);
    const r = Math.max(0.01, d.secondMarkSideR);
    [d.W * 0.5 - offset, d.W * 0.5 + offset].forEach((y) => {
      fillCircle(ctx, d, color, x, clamp(y, 0, d.W), r);
    });
  }

  function strokeSubstitutionMarks(ctx, d, color) {
    const fromHalf = Math.max(0, d.substitutionMarkDistanceFromHalf);
    const zoneLength = Math.max(0, d.substitutionZoneLength);
    const halfLen = Math.max(d.line, d.substitutionMarkLength) * 0.5;
    const touchline = d.substitutionTouchline === 'bottom' || d.substitutionTouchline === 'both'
      ? d.substitutionTouchline
      : 'top';
    const edges = touchline === 'both' ? ['top', 'bottom'] : [touchline];
    [fromHalf, fromHalf + zoneLength].forEach((distance) => {
      const xLeft = clamp((d.L * 0.5) - distance, 0, d.L);
      const xRight = clamp((d.L * 0.5) + distance, 0, d.L);
      [xLeft, xRight].forEach((x) => {
        edges.forEach((edge) => {
          if (edge === 'bottom') {
            strokeLine(ctx, d, color, x, d.W - halfLen, x, d.W + halfLen, d.line);
          } else {
            strokeLine(ctx, d, color, x, -halfLen, x, halfLen, d.line);
          }
        });
      });
    });
  }

  const PARTS = [
    makePart('futsalLeftHalf', 10, 'area', 'main', 'left', (ctx, d, color) => fillRect(ctx, d, color, 0, 0, d.L * 0.5, d.W)),
    makePart('futsalRightHalf', 20, 'area', 'main', 'right', (ctx, d, color) => fillRect(ctx, d, color, d.L * 0.5, 0, d.L * 0.5, d.W)),
    makePart('futsalLeftPenaltyArea', 30, 'key', 'key', 'left', (ctx, d, color) => fillPenaltyArea(ctx, d, color, 'left')),
    makePart('futsalRightPenaltyArea', 40, 'key', 'key', 'right', (ctx, d, color) => fillPenaltyArea(ctx, d, color, 'right')),
    makePart('futsalSidelineTop', 200, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'top')),
    makePart('futsalSidelineBottom', 210, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'bottom')),
    makePart('futsalGoalLineLeft', 220, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'left')),
    makePart('futsalGoalLineRight', 230, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'right')),
    makePart('futsalHalfwayLine', 240, 'line', 'lines', 'center', (ctx, d, color) => strokeLine(ctx, d, color, d.L * 0.5, 0, d.L * 0.5, d.W, d.line)),
    makePart('futsalCenterMark', 245, 'line', 'lines', 'center', (ctx, d, color) => fillCircle(ctx, d, color, d.L * 0.5, d.W * 0.5, d.penaltyMarkR)),
    makePart('futsalCenterCircle', 250, 'line', 'lines', 'center', (ctx, d, color) => strokeCircle(ctx, d, color, d.L * 0.5, d.W * 0.5, Math.max(0.001, Math.min(d.centerR, d.L * 0.5, d.W * 0.5) - d.line * 0.5), d.line)),
    makePart('futsalLeftPenaltyAreaLine', 260, 'line', 'lines', 'left', (ctx, d, color) => strokePenaltyArea(ctx, d, color, 'left')),
    makePart('futsalRightPenaltyAreaLine', 270, 'line', 'lines', 'right', (ctx, d, color) => strokePenaltyArea(ctx, d, color, 'right')),
    makePart('futsalLeftPenaltyMark', 280, 'line', 'lines', 'left', (ctx, d, color) => fillCircle(ctx, d, color, clamp(d.penaltyMark, 0, d.L), d.W * 0.5, d.penaltyMarkR)),
    makePart('futsalRightPenaltyMark', 290, 'line', 'lines', 'right', (ctx, d, color) => fillCircle(ctx, d, color, clamp(d.L - d.penaltyMark, 0, d.L), d.W * 0.5, d.penaltyMarkR)),
    makePart('futsalLeftSecondPenaltyMark', 300, 'line', 'lines', 'left', (ctx, d, color) => fillCircle(ctx, d, color, clamp(d.secondMark, 0, d.L), d.W * 0.5, d.penaltyMarkR)),
    makePart('futsalRightSecondPenaltyMark', 310, 'line', 'lines', 'right', (ctx, d, color) => fillCircle(ctx, d, color, clamp(d.L - d.secondMark, 0, d.L), d.W * 0.5, d.penaltyMarkR)),
    makePart('futsalLeftSecondPenaltySideMarks', 320, 'line', 'lines', 'left', (ctx, d, color) => fillSecondPenaltySideMarks(ctx, d, color, 'left')),
    makePart('futsalRightSecondPenaltySideMarks', 330, 'line', 'lines', 'right', (ctx, d, color) => fillSecondPenaltySideMarks(ctx, d, color, 'right')),
    makePart('futsalLeftGoalkeeperDistanceMark', 340, 'line', 'lines', 'left', (ctx, d, color) => strokeGoalkeeperDistanceMark(ctx, d, color, 'left')),
    makePart('futsalRightGoalkeeperDistanceMark', 350, 'line', 'lines', 'right', (ctx, d, color) => strokeGoalkeeperDistanceMark(ctx, d, color, 'right')),
    makePart('futsalCornerArcs', 360, 'line', 'lines', 'center', (ctx, d, color) => strokeCornerArcs(ctx, d, color)),
    makePart('futsalCornerDistanceMarks', 365, 'line', 'lines', 'center', (ctx, d, color) => strokeCornerDistanceMarks(ctx, d, color)),
    makePart('futsalSubstitutionMarks', 370, 'line', 'lines', 'center', (ctx, d, color) => strokeSubstitutionMarks(ctx, d, color)),
    makePart('futsalGoalLeft', 380, 'line', 'lines', 'left', (ctx, d, color) => drawGoal(ctx, d, color, 'left')),
    makePart('futsalGoalRight', 390, 'line', 'lines', 'right', (ctx, d, color) => drawGoal(ctx, d, color, 'right'))
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => {
    acc[part.id] = part;
    return acc;
  }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) {
      if (detailColors[id] === SKIP_COLOR) return null;
      return detailColors[id];
    }
    if (fallbackColors && fallbackColors[id]) {
      if (fallbackColors[id] === SKIP_COLOR) return null;
      return fallbackColors[id];
    }
    if (fallback === 'key') return baseColor.key || baseColor.main;
    if (fallback === 'border') return baseColor.border || baseColor.main;
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#15803D',
    key: '#0F6B34',
    border: '#064E3B',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    const dims = computeDims(cw, ch, opts || {});
    dims.hardwood = opts && opts.hardwood;
    dims.pattern = opts && opts.pattern;
    dims.patternTargetPrefix = opts && opts.patternTargetPrefix;
    const palette = {
      main: DEFAULT_PALETTE.main,
      key: DEFAULT_PALETTE.key,
      border: DEFAULT_PALETTE.border,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        dims.patternTarget = { id: (dims.patternTargetPrefix || '') + id, role: part.role, fallback: part.fallback };
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        try { console.warn('[SwishFutsalLines] draw error for part', id, err); } catch (_) {}
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: DEFAULTS.WIDTH * 1000, L: DEFAULTS.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
